import { CreateFileSystemModule } from "./CreateFileSystemModule";

export { CreateFileSystemModule } from "./CreateFileSystemModule";

export { MUTATION_TYPES } from "./CreateFileSystemModule";

export const FileSystemModule = CreateFileSystemModule("/filesystem"); // backwards compatible Store.
